import React from 'react';
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

export default function History_illness_Chart() {
  const labels = ['Stomachache', 'Toothache', 'Other', 'Covid', 'Headache']

  const dataNew = {
    labels,
  datasets: [
    {
      label: '%',
      data: [35,12,41,10,2],
      backgroundColor: [
        '#FFB9B9',
        '#C4B9FF',
        '#FFB9F7',
        '#FFE1B9',
        '#B9FFC1'
      ],
      borderWidth: 1,
    },
  ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
      },
      title: {
        display: false,
        text: "Chart.js Bar Chart",
        align: "center",
      }
    },
  };

  return (
    <Chart type='pie' style={{ height: "400px", maxHeight:'400px' }} options={options} data={dataNew} />
  );
}
